import { createAction } from '@reduxjs/toolkit';
import { LocalAnnotationCommand } from './types';
import { Annotation } from 'src/models/annotation';

interface AnnotationQueueCommandPayload {
  command: LocalAnnotationCommand;
}

/** An action that is dispatched when the user performs an action relating to an annotation. */
const annotationQueueCommand = createAction<AnnotationQueueCommandPayload>('ANNOTATION.COMMAND.QUEUE');

/** An action that is dispatched when the system begins processing the annotations command queue. */
const annotationQueueProcessStart = createAction('ANNOTATION.COMMAND.QUEUE.PROCESS.START');
/** An action that is dispatched when the system completes processing the annotations command queue. */
const annotationQueueProcessComplete = createAction('ANNOTATION.COMMAND.QUEUE.PROCESS.COMPLETE');

interface AnnotationSyncCommandPayload {
  /** The unique id of the command. */
  commandId: string;
}

/** An action that is dispatched when the system begins syncing an annotation command. */
const annotationSyncCommandStart = createAction<AnnotationSyncCommandPayload>('ANNOTATION.COMMAND.SYNC.START');

interface AnnotationSyncCommandSuccessPayload extends AnnotationSyncCommandPayload {
  /** The resulting annotation data. */
  data: Annotation;
  /** The type of operation that was performed. */
  type: LocalAnnotationCommand['type'];
}

/** An action that is dispatched when the system completes syncing an annotation command successfully. */
const annotationSyncCommandSuccess = createAction<AnnotationSyncCommandSuccessPayload>(
  'ANNOTATION.COMMAND.SYNC.SUCCESS',
);

/** An action that is dispatched when the system completes syncing an annotation command unsuccessfully. */
const annotationSyncCommandFailure = createAction<AnnotationSyncCommandPayload>('ANNOTATION.COMMAND.SYNC.FAILURE');

interface AnnotationClaimCommandPayload {
  /** The local key for which to claim. */
  parentClaimKey: string;
  /** The unique id of the entity to associate with all annotations being claimed. */
  parentId: string;
}

/** An action that is dispatched when an entity is able to claim local annotations associated with it. */
const annotationClaimCommand = createAction<AnnotationClaimCommandPayload>('ANNOTATION.COMMAND.CLAIM');

export const annotationActions = {
  annotationQueueCommand,
  annotationQueueProcessStart,
  annotationQueueProcessComplete,
  annotationSyncCommandStart,
  annotationSyncCommandSuccess,
  annotationSyncCommandFailure,
  annotationClaimCommand,
};
